module.exports = __webpack_public_path__ + "static/img/screenshot-bg.0676d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/screenshot-bg.png
// module id = M8Po
// module chunks = 36